import React from "react";
import { connect } from "react-redux";
import Button from "components/CustomButtons/Button.jsx";
import "assets/scss/responsive.css";
import "./customstyle.css";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import ChartistGraph from "react-chartist";

import Timeline from "@material-ui/icons/Timeline";
import withStyles from "@material-ui/core/styles/withStyles";

import chartsStyle from "assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx";
import API from "@aws-amplify/api";
import Slider from "@material-ui/lab/Slider";
import { Chart } from "react-google-charts";

let apiName = process.env.REACT_APP_AMPLIFY_API;

// core components
class Summary extends React.Component {
  constructor(props) {
    super(props);
    //this.props.dispatch({ type: "SHOW_TABS", payload: "no" });
    // this.apiFetch();
  }

  componentDidMount() {
    let count = 0;
    this.setState({ updateSummary: true });
    if (this.props.editMode != undefined) {
      setTimeout(() => {
        this.apiFetch("where");
      }, 1000);
    } else {
      this.apiFetch("no_where");
    }
  }

  state = {
    dataAge: [],
    dataIncome: [],
    dataLifeDrivers: [],
    dataLifeDriversDup: [],
    excludedCount: 0,
    showSummary: true,
    updateSummary: false,
    query_count: "",
    full_count: "",
    address_count: "",
    email_count: "",
    remainder: 0,
    tempdataLifeDrivers: [],
  };

  getSegmentsData(where) {
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.props.groupLeveltoggleSegment;
    let ruleLeveltoggle = this.props.ruleLeveltoggleSegment;
    let count = 0;
    let sqlAndOrOperator = "";
    this.props.tillSqlSelectionArrSegment.map((resultData, index) => {
      let segment = "";
      if (this.props.segmentName[index] != undefined) {
        segment = this.props.segmentName[index];
      }
      selectedRule += `WHEN `;
      resultData.map((options, key) => {
        let length = options.length;
        if (options[length - 2].value.includes("+++")) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
        }
        selectedRule +=
          "(" + options[length - 2].value + " " + options[length - 1].value;
        let data = this.props.afterSqlSelectionArrSegment[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `))`;
                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
              }
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                selectedRule += ` ${result.value}) AND cac_addr_state='IN'),`;
              } else if (typeof num == "string") {
                selectedRule += ` '${result.value}'), `;
              } else {
                selectedRule += ` ${result.value}), `;
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
              }
            }
          });
        }
      });
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedRule += ` THEN `;
      selectedRule += ` '${segment}' `;
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
    });
    if (selectedRule != "") {
      let fQS = "";
      if (where == "") {
        fQS =
          "SELECT segment, count(*) as count from (SELECT CASE " +
          selectedRule +
          "ELSE 'Remainder' END AS segment FROM " +
          process.env.REACT_APP_ATHENA_TABLE +
          " WHERE cac_addr_state='IN' ) GROUP BY segment";
      } else {
        fQS =
          "SELECT segment, count(*) as count from (SELECT CASE " +
          selectedRule +
          "ELSE 'Remainder' END AS segment FROM " +
          process.env.REACT_APP_ATHENA_TABLE +
          " WHERE " +
          where +
          ") GROUP BY segment";
      }
      let myInitCount = {
        headers: {},
        body: {
          sql: fQS,
          isSegment: true,
        },
      };
      if (
        this.props.summaryDetails["segment_details"]["condition"] === "" ||
        this.props.summaryDetails["segment_details"]["condition"] !== fQS
      ) {
        API.post(apiName, "/counts", myInitCount)
          .then((response) => {
            this.props.dispatch({
              type: "UPDATE_SUMMARY_DETAILS",
              segmentPayload: fQS,
              segmentValue: response,
            });
            this.props.dispatch({ type: "Add" });
            this.prepareSegmentsData(response);
          })
          .catch((error) => {
            this.setState({ remainder: 0 });
          });
      } else {
        if (
          this.props.summaryDetails["segment_details"]["value"] !== undefined
        ) {
          this.prepareSegmentsData(
            this.props.summaryDetails["segment_details"]["value"]
          );
        }
      }
    } else {
      this.setState({ remainder: 0 });
    }
  }

  prepareSegmentsData(response) {
    let res = response["final_result"]["Items"];
    if (res != undefined) {
      this.props.dispatch({
        type: "UPDATE_QUERY_COUNT_SEGMENT",
        segmentData: response["final_result"]["Items"],
      });
      this.props.dispatch({ type: "Add" });
      for (let data in res) {
        if (res[data].segment === "Remainder") {
          this.setState({ remainder: res[data].count });
        }
      }
    } else {
      this.setState({ remainder: 0 });
    }
  }

  getWhereCondition() {
    let self = this;
    let groupLeveltoggle = self.props.groupLeveltoggle;
    let ruleLeveltoggle = self.props.ruleLeveltoggle;
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let count = 0;
    let sqlAndOrOperator = "";
    self.props.tillSqlSelectionArr.map((resultData, index) => {
      selectedRule += `(`;
      resultData.map((options, key) => {
        let length = options.length;
        if (options[length - 2].value.includes("+++")) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
        }
        selectedRule +=
          "(" + options[length - 2].value + " " + options[length - 1].value;
        let data = self.props.afterSqlSelectionArr[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `) AND cac_addr_state='IN')`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
              }
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                selectedRule += ` ${result.value}) AND cac_addr_state='IN'),`;
              } else if (typeof num == "string") {
                selectedRule += ` '${result.value}' AND cac_addr_state='IN'),`;
              } else {
                selectedRule += ` ${result.value} AND cac_addr_state='IN'),`;
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
              }
            }
          });
        }
      });
      selectedRule += `)`;
      sqlAndOrOperator = "";
      if (
        groupLeveltoggle.length > 0 &&
        self.props.tillSqlSelectionArr.length - 1 != index &&
        groupLeveltoggle[0] != undefined &&
        groupLeveltoggle[0][index] != undefined
      ) {
        sqlAndOrOperator = groupLeveltoggle[0][index];
        selectedRule += ` ${sqlAndOrOperator} `;
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      // self.setState({ query: selectedRule });
    });
    return selectedRule;
  }

  fetchChartsData(whereCondition) {
    let myInitCount = {
      headers: {},
      body: {
        isSihlouttes: true,
        where: whereCondition,
      },
    };
    whereCondition = whereCondition === "" ? "-" : whereCondition;
    API.post(apiName, "/counts", myInitCount)
      .then((response) => {
        let backResp = JSON.parse(
          response["final_result"]["Items"][0]["results"]
        );
        //this.state.totalUniverse = backResp['total_universe']['total_universe'];
        this.props.dispatch({
          type: "UPDATE_SUMMARY_DETAILS",
          chartsPayload: whereCondition,
          chartsValue: backResp,
        });
        this.props.dispatch({ type: "Add" });
        this.prepareIncomeAgeDrivers(backResp);
      })
      .catch((error) => {
        this.setState({ showSummary: false });
        //this.props.dispatch({ type: "SHOW_TABS", payload: "yes" });
      });
  }

  fetchQueryData(fQS) {
    setTimeout(() => {
      let myInitCount = {
        headers: {},
        body: {
          sql: fQS,
        },
      };
      let query_count = "";
      let full_count = "";
      let address_count = "";
      let email_count = "";
      API.post(apiName, "/counts", myInitCount)
        .then((response) => {
          this.props.dispatch({
            type: "UPDATE_SUMMARY_DETAILS",
            queryPayload: fQS,
            queryValue: response,
          });
          this.props.dispatch({ type: "Add" });
          this.prepareQueryData(response);
        })
        .catch((error) => {
          this.setState({ email_count: "" });
          this.setState({ full_count: "" });
          this.setState({ address_count: "" });
          this.setState({ email_count: "" });
          this.setState({ showSummary: false });
          if (this.props.editMode != undefined) {
            this.props.dispatch({
              type: "UPDATE_QUERY_COUNT",
              query_count: " ",
              full_count: " ",
              address_count: " ",
              email_count: " ",
              preview: [],
            });
          } else {
            this.props.dispatch({
              type: "CUSTOM_QUERY_COUNT",
              query_count: "",
              full_count: "",
              address_count: "",
              email_count: "",
              preview: [],
            });
          }
        });
    }, 1000);
  }

  prepareQueryData(response) {
    let query_count = "";
    let full_count = "";
    let address_count = "";
    let email_count = "";
    if (
      response["final_result"] !== undefined &&
      response["final_result"]["Items"] !== undefined &&
      response["final_result"]["Items"].length > 0 &&
      response["final_result"]["Items"][0]["_col0"] !== undefined
    ) {
      query_count = response["final_result"]["Items"][0]["_col0"];
    }
    if (
      response["full_result"] !== undefined &&
      response["full_result"]["Items"] !== undefined &&
      response["full_result"]["Items"].length > 0 &&
      response["full_result"]["Items"][0]["_col0"] !== undefined
    ) {
      full_count = response["full_result"]["Items"][0]["_col0"];
    }
    if (
      response["address_result"] !== undefined &&
      response["address_result"]["Items"] !== undefined &&
      response["address_result"]["Items"].length > 0 &&
      response["address_result"]["Items"][0]["_col0"] !== undefined
    ) {
      address_count = response["address_result"]["Items"][0]["_col0"];
      // this.setState({address_count: response["address_result"]["Items"][0]["_col0"]})
    }
    if (
      response["email_result"] !== undefined &&
      response["email_result"]["Items"] !== undefined &&
      response["email_result"]["Items"].length > 0 &&
      response["email_result"]["Items"][0]["_col0"] !== undefined
    ) {
      email_count = response["email_result"]["Items"][0]["_col0"];
      // this.setState({email_count: response["email_count"]["Items"][0]["_col0"]})
    }
    this.setState({ query_count });
    this.setState({ full_count });
    this.setState({ address_count });
    this.setState({ email_count });
    this.setState({ showSummary: false });
    this.setState({
      excludedCount: Math.round(
        (query_count * this.props.sliderValue["sliderValue"]) / 100
      ),
    });
    if (this.props.editMode != undefined) {
      this.props.dispatch({
        type: "UPDATE_QUERY_COUNT",
        query_count: query_count,
        full_count: full_count,
        address_count: address_count,
        email_count: email_count,
        preview: [],
      });
    } else {
      this.props.dispatch({
        type: "CUSTOM_QUERY_COUNT",
        query_count: query_count,
        full_count: full_count,
        address_count: address_count,
        email_count: email_count,
        preview: [],
      });
    }
    //this.props.dispatch({ type: "SHOW_TABS", payload: "yes" });
    this.props.dispatch({ type: "Add" });
  }

  prepareIncomeAgeDrivers(backResp) {
    let tempdataLifeDrivers = backResp["life_drivers"];
    this.setState({ tempdataLifeDrivers });
    let tempdataIncome = backResp["income"];
    let tempdataAge = backResp["age"];
    let tempArray = [["Life Driver", "Included", "Control Group"]];
    //let tempArray = [['Life Driver', 'IncludedCount', 'ExcludedCount']];

    for (let key in tempdataLifeDrivers) {
      let y = [];
      let lD = tempdataLifeDrivers[key] * 50;
      let upValue = Math.round(
        (lD * this.props.sliderValue["sliderValue"]) / 100
      );
      y.push(key);
      y.push(lD - upValue);
      y.push(upValue);
      tempArray.push(y);
    }
    this.setState({ dataLifeDrivers: tempArray });
    this.setState({ dataLifeDriversDup: tempArray });

    tempArray = [["Income", "INCount"]];
    for (let key in tempdataIncome) {
      let y = [];
      let lD = tempdataIncome[key] * 50;
      y.push(key);
      y.push(lD);
      tempArray.push(y);
    }
    this.setState({ dataIncome: tempArray });

    tempArray = [["Age", "AgeCount"]];
    for (let key in tempdataAge) {
      let y = [];
      let lD = tempdataAge[key] * 50;
      y.push(key);
      y.push(lD);
      tempArray.push(y);
    }
    this.setState({ dataAge: tempArray });
  }

  apiFetch(where) {
    let whereCondition = "";
    whereCondition = this.getWhereCondition();
    this.getSegmentsData(whereCondition);
    let condition = whereCondition === "" ? "-" : whereCondition;
    if (
      this.props.summaryDetails["charts_details"]["condition"] === "" ||
      this.props.summaryDetails["charts_details"]["condition"] !== condition
    ) {
      this.fetchChartsData(whereCondition);
    } else {
      if (this.props.summaryDetails["charts_details"]["value"] !== undefined) {
        this.prepareIncomeAgeDrivers(
          this.props.summaryDetails["charts_details"]["value"]
        );
      } else {
        this.fetchChartsData(whereCondition);
      }
    }
    let fQS = "SELECT count(*) FROM " + process.env.REACT_APP_ATHENA_TABLE;
    if (whereCondition != "") {
      fQS = fQS + " WHERE " + whereCondition;
    }
    if (
      this.props.summaryDetails["query_details"]["condition"] === "" ||
      this.props.summaryDetails["query_details"]["condition"] !== fQS
    ) {
      this.fetchQueryData(fQS);
    } else {
      if (this.props.summaryDetails["query_details"]["value"] !== undefined) {
        this.prepareQueryData(
          this.props.summaryDetails["query_details"]["value"]
        );
      } else {
        this.fetchQueryData(fQS);
      }
    }
  }

  numberWithCommas = (x) => {
    if (x != undefined) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return "";
    }
  };

  // handleChange = (event, value) => {
  //   this.setState({ sliderValue: value });
  //   this.setState({ excludedCount: Math.round((this.state.query_count * value)/100) })
  //   let tempArray = [['Life Driver', 'ActualCount', 'ExcludedCount']];
  //    for (let key in this.state.tempdataLifeDrivers){
  //    let y = []
  //    let upValue = Math.round( (this.state.tempdataLifeDrivers[key] * value)/100 );
  //    y.push(key);
  //    y.push(this.state.tempdataLifeDrivers[key] - upValue);
  //    y.push(upValue);
  //    tempArray.push(y);
  //   }
  //   this.setState({dataLifeDrivers: tempArray});
  //   this.setState({dataLifeDriversDup: tempArray});
  // };
  render() {
    const { classes } = this.props;
    let showSpinner = "";
    let totPopulation = 0;
    let actPopulation = 0;
    // let progressPercentage = 0;
    // if (this.props.queryCount['query_count'] != " ") {
    //   totPopulation = this.props.queryCount['full_count'] != ' ' ? this.props.queryCount['full_count'] : 0;
    //   actPopulation = this.props.queryCount['query_count'] != ' ' ? this.props.queryCount['query_count'] : 0;
    //   progressPercentage = totPopulation !== 0 ? Math.round((actPopulation/totPopulation)*100) : 0;
    // } else {
    //   progressPercentage = 100
    // }
    // if (this.props.showQuerySpinner === "yes") {
    //   showSpinner = (
    //     <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px" }} />
    //   );
    // } else {
    //   showSpinner = this.numberWithCommas(this.props.queryCount['query_count']);
    // }
    let showPage = "";
    if (this.state.showSummary === true) {
      showPage = (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardBody style={{ textAlign: "center" }}>
                <div style={{ textAlign: "center", width: "100%" }}>
                  <i
                    className="fa fa-spinner fa-spin"
                    style={{ fontSize: "50px" }}
                  />
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      );
    } else {
      showPage = (
        <React.Fragment>
          <GridItem
            xs={8}
            sm={8}
            md={8}
            xl={8}
            style={{ width: "61%", display: "inline-block", float: "right" }}
          >
            <Card style={{}}>
              <CardHeader color="danger" icon>
                <CardIcon color="danger">
                  <Timeline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Life Drivers</h4>
              </CardHeader>
              <CardBody
                style={{
                  display: "block",
                  transitionDuration: "0.3s",
                  paddingBottom: "60px !important",
                }}
              >
                <Chart
                  width={"100%"}
                  height={"35vh"}
                  chartType="ColumnChart"
                  loader={<div>Loading Chart</div>}
                  data={
                    /*[
                        ['Segments', 'Count', 'Percentages'],
                        ['Seg-1', 8175000, 8008000],
                        ['Seg-2', 3792000, 3694000],
                        ['Remainder', 2695000, 2896000]
                      ]*/
                    this.state.dataLifeDriversDup
                  }
                  options={{
                    //title: 'Population of Largest U.S. Cities',
                    //chartArea: { width: '50%' },
                    isStacked: true,
                    vAxis: {
                      title: "Total Audience",
                      minValue: 0,
                    },
                    hAxis: {
                      title: "Segments",
                    },
                    colors: [
                      // "#f5801f",
                      "#69ff45",
                      "#808080",
                      "#6691c6",
                      "#b4413e",
                      "#6d833d",
                      "#7e60a0",
                      "#ffff47",
                      "#d30fae",
                      "#3599b8",
                      "#dfbfbf",
                      "#4ac5bb",
                      "#5f6b6d",
                      "#fb8281",
                      "#f4d25a",
                      "#7f898a",
                      "#a4ddee",
                      "#fdab89",
                      "#b687ac",
                      "#28738a",
                      "#a78f8f",
                      "#168980",
                      "#293537",
                      "#bb4a4a",
                      "#b59525",
                      "#475052",
                    ],
                  }}
                  // For tests
                  rootProps={{ "data-testid": "3" }}
                />
              </CardBody>
            </Card>
          </GridItem>
          <GridContainer>
            {/* <GridItem xs={12} sm={12} md={4} xl={4}>
              <Card style={{ height: "60vh" }}>
                <div className="filtercentercontent summarycontent">
                  <div className="filteraudiencetitle summarytitle">
                    <h2 className="capitalize">Counts</h2>
                  </div>
                  <CardBody>
                    <div style={{ paddingTop: "20px" }}>
                      <h2
                        style={{
                          textAlign: "left",
                          float: "left",
                          color: "#417a94",
                        }}
                      >
                        Total Universe{" "}
                      </h2>
                      <h2
                        style={{
                          textAlign: "right",
                          float: "right",
                          color: "#417a94",
                          display: "inline",
                        }}
                      >
                        <strong>
                          {" "}
                          {this.numberWithCommas(this.state.full_count)}{" "}
                        </strong>
                      </h2>
                      <br />
                      <br />
                      <h2
                        style={{
                          textAlign: "left",
                          float: "left",
                          color: "#417a94",
                        }}
                      >
                        Targeted Audience{" "}
                      </h2>
                      <h2
                        style={{
                          textAlign: "right",
                          float: "right",
                          color: "#417a94",
                          display: "inline",
                        }}
                      >
                        <strong>
                          {" "}
                          {this.numberWithCommas(this.state.query_count)}{" "}
                        </strong>
                      </h2>
                      <br />
                      <br />
                      <h2
                        style={{
                          textAlign: "left",
                          float: "left",
                          color: "#417a94",
                        }}
                      >
                        Targeted with Email{" "}
                      </h2>
                      <h2
                        style={{
                          textAlign: "right",
                          float: "right",
                          color: "#417a94",
                          display: "inline",
                        }}
                      >
                        <strong>
                          {" "}
                          {this.numberWithCommas(this.state.email_count)}{" "}
                        </strong>
                      </h2>
                      <br />
                      <br />
                      <h2
                        style={{
                          textAlign: "left",
                          float: "left",
                          color: "#417a94",
                        }}
                      >
                        Targeted with Address{" "}
                      </h2>
                      <h2
                        style={{
                          textAlign: "right",
                          float: "right",
                          color: "#417a94",
                          display: "inline",
                        }}
                      >
                        <strong>
                          {" "}
                          {this.numberWithCommas(this.state.address_count)}{" "}
                        </strong>
                      </h2>
                      <br />
                      <br />
                      <h2
                        style={{
                          textAlign: "left",
                          float: "left",
                          color: "#417a94",
                        }}
                      >
                        Segmented{" "}
                      </h2>
                      <h2
                        style={{
                          textAlign: "right",
                          float: "right",
                          color: "#417a94",
                          display: "inline",
                        }}
                      >
                        <strong>
                          {" "}
                          {this.numberWithCommas(
                            this.state.query_count - this.state.remainder
                          )}{" "}
                        </strong>
                      </h2>
                      <br />
                      <br />
                      <h2
                        style={{
                          textAlign: "left",
                          float: "left",
                          color: "#417a94",
                        }}
                      >
                        Unsegmented{" "}
                      </h2>
                      <h2
                        style={{
                          textAlign: "right",
                          float: "right",
                          color: "#417a94",
                          display: "inline",
                        }}
                      >
                        <strong>
                          {" "}
                          {this.numberWithCommas(this.state.remainder)}{" "}
                        </strong>
                      </h2>
                      <br />
                      <br />
                      <h2
                        style={{
                          textAlign: "left",
                          float: "left",
                          color: "#417a94",
                        }}
                      >
                        Control Group{" "}
                      </h2>
                      <h2
                        style={{
                          textAlign: "right",
                          float: "right",
                          color: "#417a94",
                          display: "inline",
                        }}
                      >
                        <strong>
                          {" "}
                          {this.numberWithCommas(this.state.excludedCount)}{" "}
                        </strong>
                      </h2>
                    </div>
                  </CardBody>
                </div>
              </Card>
            </GridItem> */}
            <GridItem xs={12} sm={12} md={6} xl={6}>
              <Card style={{ height: "60vh" }}>
                <CardHeader color="danger" icon>
                  <CardIcon color="danger">
                    <Timeline />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>Age</h4>
                </CardHeader>
                <CardBody
                  style={{ justifyContent: "center", textAlign: "center" }}
                >
                  <Chart
                    width={"100%"}
                    height={"50vh"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state.dataAge}
                    options={{
                      legend: { position: "top", maxLines: 2 },
                      colors: [
                        // "#f5801f",
                        "#69ff45",
                        "#808080",
                        "#6691c6",
                        "#b4413e",
                        "#6d833d",
                        "#7e60a0",
                        "#ffff47",
                        "#d30fae",
                        "#3599b8",
                        "#dfbfbf",
                        "#4ac5bb",
                        "#5f6b6d",
                        "#fb8281",
                        "#f4d25a",
                        "#7f898a",
                        "#a4ddee",
                        "#fdab89",
                        "#b687ac",
                        "#28738a",
                        "#a78f8f",
                        "#168980",
                        "#293537",
                        "#bb4a4a",
                        "#b59525",
                        "#475052",
                      ],
                      chartArea: { width: "95%", height: "80%" },
                      //title: 'Age',
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} xl={6}>
              <Card style={{ height: "60vh" }}>
                <CardHeader color="danger" icon>
                  <CardIcon color="danger">
                    <Timeline />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>Income</h4>
                </CardHeader>
                <CardBody
                  style={{ justifyContent: "center", textAlign: "center" }}
                >
                  <Chart
                    width={"100%"}
                    height={"50vh"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state.dataIncome}
                    options={{
                      legend: { position: "top", maxLines: 4 },
                      colors: [
                        // "#f5801f",
                        "#69ff45",
                        "#808080",
                        "#6691c6",
                        "#b4413e",
                        "#6d833d",
                        "#7e60a0",
                        "#ffff47",
                        "#d30fae",
                        "#3599b8",
                        "#dfbfbf",
                        "#4ac5bb",
                        "#5f6b6d",
                        "#fb8281",
                        "#f4d25a",
                        "#7f898a",
                        "#a4ddee",
                        "#fdab89",
                        "#b687ac",
                        "#28738a",
                        "#a78f8f",
                        "#168980",
                        "#293537",
                        "#bb4a4a",
                        "#b59525",
                        "#475052",
                      ],
                      chartArea: { width: "95%", height: "80%" },
                      //title: 'Age',
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </React.Fragment>
      );
    }
    return <React.Fragment>{showPage}</React.Fragment>;
  }
}
const mapStateToProps = (state) => ({
  count: state.count,
  tillSqlSelectionArr: state.tillSqlSelectionArr,
  afterSqlSelectionArr: state.afterSqlSelectionArr,
  ruleLeveltoggle: state.ruleLeveltoggle,
  groupLeveltoggle: state.groupLeveltoggle,
  title: state.title,
  listDescription: state.listDescription,
  queryCount: state.queryCount,
  showQuerySpinner: state.showQuerySpinner,
  previewData: state.previewData,

  countSegment: state.countSegment,
  tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
  afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
  ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
  groupLeveltoggleSegment: state.groupLeveltoggleSegment,

  queryCountSegment: state.queryCountSegment,
  showQuerySpinnerSegment: state.showQuerySpinnerSegment,
  previewDataSegment: state.previewDataSegment,
  segmentName: state.segmentName,
  segmentData: state.segmentData,
  hideTabs: state.hideTabs,
  queryCountTempSegment: state.queryCountTempSegment,
  sliderValue: state.sliderValue,
  summaryDetails: state.summaryDetails,
});

export default connect(mapStateToProps)(withStyles(chartsStyle)(Summary));



// WEBPACK FOOTER //
// ./src/views/Audiences/Summary.jsx